import React, { FC, useMemo } from 'react';
import { ToastMessageCont } from './ToastMessage.styles';
import Portal from '../../HOC/Portal/Portal';
import { useToast } from '../../hooks/useToast';
import Notification from '../Notification/Notification';

const ToastMessage: FC = () => {
  const { toastData, hideToastMessage } = useToast();
  const toastVisibility = !!toastData;

  const renderToast = useMemo(
    () => (
      <ToastMessageCont>
        {toastData && <Notification data={toastData} closePanel={hideToastMessage} />}
      </ToastMessageCont>
    ),
    [hideToastMessage, toastData]
  );

  return <>{toastVisibility && <Portal portalId="toast">{renderToast}</Portal>}</>;
};

export default ToastMessage;
